import YouTube from "react-youtube";
import PropTypes from "prop-types";

const IframeContainer = (props) => {
  const youtubeRegex = new RegExp(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?(.*&)?v=|(?:embed|v)\/))([^?&"'>]+)/
  );
  const youtubeMatch = props.source.match(youtubeRegex);

  let iframeSheetStyle = {
    transform: "scale3d(" + props.pageScale + "," + props.pageScale + ",1)",
    transformOrigin: "top left",
    height: "100vh",
    border: "0",
  };

  if (youtubeMatch && youtubeMatch[2]) {
    const videoId = youtubeMatch[2];
    return (
      <YouTube
        id="ytplayer"
        onReady={(e) => {
          e.target.playVideo();
        }}
        onError={(e) => {
          props.setError("videoUnavailable");
        }}
        opts={{
          playerVars: {
            controls: 0,
            showinfo: 0,
            disablekb: 0,
            autoplay: 1,
          },
        }}
        videoId={videoId}
      />
    );
  } else {
    return (
      <iframe
        title="your site"
        id="embed-frame"
        src={props.source}
        style={iframeSheetStyle}
      />
    );
  }
};

IframeContainer.propTypes = {
  source: PropTypes.string,
  setError: PropTypes.func,
  pageScale: PropTypes.number,
};

export default IframeContainer;
